import {OVERFLOW_HIDDEN, POPUP_OPEN} from '../constants/constants';
import eventBus from '../event-bus/event-bus';
import vClickOutside from 'v-click-outside';

export default {
	props: {
		name: {
			type: String,
			required: false,
			default: 'popup'
		}
	},
	data() {
		return {
			isOpened: false,
			position: null
		};
	},
	directives: {
		clickOutside: vClickOutside.directive
	},
	watch: {
		isOpened(newValue) {
			if (newValue) {
				this.position = window.scrollY;
				// TODO - ezt visszatenni ha mar megjelenik normalisan a modal
				// document.body.classList.add(OVERFLOW_HIDDEN);
				document.body.classList.add(POPUP_OPEN);
				setTimeout(() => {
					document.body.addEventListener('click', this.clickOutsideHandler);
					document.body.addEventListener('keyup', this.escapeHandler);
					window.addEventListener('resize', this.calculateModalType);
				});
			} else {
				document.body.classList.remove(OVERFLOW_HIDDEN);
				document.body.classList.remove(POPUP_OPEN);
				window.scrollTo(0, this.position);
				document.body.removeEventListener('click', this.clickOutsideHandler);
				document.body.removeEventListener('keyup', this.escapeHandler);
				window.removeEventListener('resize', this.calculateModalType);
			}
		}
	},
	created() {
		eventBus.$on('open-' + this.name, this.open);
		eventBus.$on('close-' + this.name, this.close);
	},
	methods: {
		close() {
			this.isOpened = false;
		},
		open() {
			this.isOpened = true;
		}
	}
};



// WEBPACK FOOTER //
// ../source/common/popup/popup.js